import script from "./FolderUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./FolderUploadModal.vue?vue&type=style&index=0&id=bd0c0464&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd0c0464"]])

export default __exports__